import { render, staticRenderFns } from "./OpeyItems.vue?vue&type=template&id=2490ae34&scoped=true"
import script from "./OpeyItems.vue?vue&type=script&lang=js"
export * from "./OpeyItems.vue?vue&type=script&lang=js"
import style0 from "./OpeyItems.vue?vue&type=style&index=0&id=2490ae34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490ae34",
  null
  
)

export default component.exports